import * as Yup from 'yup';
import {getSelectItemLabel, ISelectItem} from '~/components/Controls/Select';
import {IModel} from '~/lib/model';
import {ISessionRoles} from '~/modules/Profile/session';
import {IUserPermission} from './UserPermission';

export enum UserRole {
    SUPERVISOR = 'supervisor',
    ADMIN = 'admin',
    BUYER = 'buyer',
    SELLER = 'seller',
    API = 'api',
    INACTIVE = 'inactive',
    MANAGER = 'manager',
    MEDIATIONPARTNER = 'mediationPartner',
    SELFSERVE = 'selfServe',
    AUTOMATION = 'automation',
    BUYERPLUS = 'buyerPlus'
}

export const userRoles: ISelectItem<UserRole>[] = [
    {value: UserRole.SUPERVISOR, label: 'Supervisor'},
    {value: UserRole.ADMIN, label: 'Admin'},
    {value: UserRole.BUYER, label: 'Buyer'},
    {value: UserRole.SELLER, label: 'Seller'},
    {value: UserRole.API, label: 'API'},
    {value: UserRole.INACTIVE, label: 'Inactive'},
    {value: UserRole.MANAGER, label: 'Manager'},
    {value: UserRole.MEDIATIONPARTNER, label: 'Mediation Partner'},
    {value: UserRole.SELFSERVE, label: 'Self-serve Seller'},
    {value: UserRole.AUTOMATION, label: 'Automation'},
    {value: UserRole.BUYERPLUS, label: 'Buyer Plus'},
];

export const getUserRoleLabel = (userRole: UserRole) => getSelectItemLabel(userRoles, userRole);

export const UserRoleSchema = Yup.mixed<UserRole>().test({
    name: 'role',
    test: (value: UserRole): value is UserRole => userRoles.findIndex(item => item.value === value) !== -1
}).required('required');

export interface IUser extends IModel {
    email: string;
    name: string;
    company: string;
    role: UserRole;
    agencyId?: number;
    permissions?: IUserPermission[];
    deleted: boolean;
}

export const UserSchema = Yup.object().shape<IUser>({
    id: Yup.number().nullable(),
    email: Yup.string().email().required(),
    name: Yup.string().required(),
    company: Yup.string(),
    role: UserRoleSchema,
    deleted: Yup.boolean().required()
});

export const defaultUser: IUser = {
    id: null,
    email: '',
    name: '',
    company: '',
    role: UserRole.INACTIVE,
    permissions: [],
    deleted: false
};
